import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿El pago es único?',
    answer: 'Sí, es un pago único de $19.990 ARS. No hay suscripciones ni pagos recurrentes. Una vez que comprás, el material es tuyo para siempre.'
  }, {
    question: '¿Cómo recibo el material?',
    answer: 'Inmediatamente después de confirmar tu pago, recibís acceso instantáneo al KIT completo en formato digital descargable. Podés acceder desde cualquier dispositivo al correo electronico que usted haya registrado en su compra.'
  }, {
    question: '¿Sirve si recién empiezo a trabajar con adultos mayores?',
    answer: 'Absolutamente. El KIT está diseñado tanto para profesionales que recién empiezan como para quienes ya trabajan con gerontes y buscan más estructura. Las guías son claras, prácticas y aplicables desde el primer día.'
  }, {
    question: '¿Reemplaza una formación o supervisión profesional?',
    answer: 'No. Este material es una herramienta educativa y profesional complementaria. No reemplaza formación específica, supervisión profesional, evaluación médica, evaluación psiquiátrica, interconsulta cuando corresponda ni criterios clínicos individuales.'
  }, {
    question: '¿Tiene garantía?',
    answer: 'Sí, tenés 7 días de garantía. Si el material no cumple con tus expectativas, te devolvemos el 100% de tu inversión sin preguntas.'
  }, {
    question: '¿Los bonos están incluidos en el precio?',
    answer: 'Sí, todos los bonos (Guía de Psicoeducación para Familias, Plantilla de Evaluación Inicial y Guía de Actividades Terapéuticas) están incluidos sin costo adicional con tu compra de hoy.'
  }];
  return <section className="w-full py-16 md:py-24 bg-[#faf9f7]" data-id="element-33">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-35">
          <h2 className="text-3xl md:text-4xl font-bold text-[#14505c] mb-12 text-center" data-id="element-36">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-4" data-id="element-37">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-38">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#d97706] focus:ring-inset" aria-expanded={openIndex === index} data-id="element-39">
                  <span className="font-bold text-[#14505c] text-lg pr-4" data-id="element-40">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-41">
                    <ChevronDown className="w-6 h-6 text-[#d97706] flex-shrink-0" data-id="element-42" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-43">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-44">
                      <div className="px-6 pb-5 text-gray-700" data-id="element-45">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}